import React from 'react';
import { Church } from '../types/church';
import AssignReportTemplatesModal from './AssignReportTemplatesModal';
import ViewChurchAssignedTemplatesModal from './ViewChurchAssignedTemplatesModal';

type Props = {
  show: boolean;
  onHide: () => void;
  church: Church | null;
  districtId: number;
  canManage: boolean;
  nationId?: number;
};

const ChurchTemplatesModal: React.FC<Props> = ({
  show,
  onHide,
  church,
  districtId,
  canManage,
  nationId,
}) => {
  if (canManage) {
    return (
      <AssignReportTemplatesModal
        show={show}
        onHide={onHide}
        church={church}
        districtId={districtId}
        nationId={nationId}
      />
    );
  }

  return (
    <ViewChurchAssignedTemplatesModal
      show={show}
      onHide={onHide}
      church={church}
    />
  );
};

export default ChurchTemplatesModal;
